export let Latitudine;
export let Longitudine;
export let LatLong;
export let url;
import { get } from "svelte/store";
import { valuesForm } from "svelte-formly";
import { set_input_value } from "svelte/internal";

url = "";
let APIrequest = "https://maps.googleapis.com/maps/api/geocode/json?address=";

export function trovaCoords() {

    var xmlHttp = new XMLHttpRequest();

    xmlHttp.onreadystatechange = function () {

        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {

            // console.log(xmlHttp.responseText);

            let risultato = xmlHttp.responseText;

            let obj = JSON.parse(risultato);

            //console.log(LatLong);
            Latitudine = obj.results[0].geometry.location.lat;
            //console.log(Latitudine);
            Longitudine = obj.results[0].geometry.location.lng;
            //console.log(Longitudine);
            LatLong = Latitudine + " , " + Longitudine;

            document.getElementById("geographic_coordinates").value = LatLong;
        }
    };
    url = trovaURL();
    xmlHttp.open("POST", url, true); // true for asynchronous
    xmlHttp.send();
}


function trovaURL() {
    let values = get(valuesForm).values;
    let tmp;

    if (values.address)
        tmp = APIrequest + values.address;

    if (values.post_code)
        tmp += "+" + values.post_code;

    if (values.location_city)
        tmp += "+" + values.location_city;

    if (values.province_region_state)
        tmp += "+" + values.province_region_state;

    if (values.country)
        tmp += "+" + values.country;

    tmp = tmp + "+CA&key=AIzaSyB8WIcB8CmhFAo8F_IlsSbcR-UGhgzq7jM";

    return tmp;
}